import * as THREE from 'three';
import { FikoCizimYalin } from './FikoCizimYalin';
import { FikoImporterWRL } from './FikoImporter.WRL';
import { FikoSahne } from './FikoSahne';
declare var flate: any;
declare var LZUTF8: any;
export class FikoImporterFikoOpGLv1 {

    constructor(public sahne?: FikoSahne) {

    }

    async alDosyadan(dosya: any): Promise<any> {
        let json: any;
        let sonuc:any = []
        let data: string[];
        let isle = (dataStr: string) => {

            return new Promise((resolve, reject) => {

                data = dataStr.split('\r\n');

                

                let operasyonlar: any[] = []

                let opi = 0;
                let opBasi = null;
                let opSoni = null;
                for (let i = 0; i < data.length; i++) {
                    const satir = data[i];

                    if (satir.startsWith("#$ FikoYT PART OPERASYONU BASLANGICI ")) {
                        if (opBasi == null)
                            opBasi = i;
                        else
                            opBasi = i;
                    }
                    if (satir.startsWith("#$ FikoYT PART OPERASYONU BITIS ")) {
                        if (opSoni == null)
                            opSoni = i;
                        else
                            opSoni = i;

                        operasyonlar.push(data.slice(opBasi, opSoni + 1).join('\r\n'));
                        opi++
                    }
                }


                // console.log(json)



                for (let oppi = 0; oppi < operasyonlar.length; oppi++) {
                    let dataop = operasyonlar[oppi];

                    // dataop = dataop.split('\r\n');
                    // dataop.shift()
                    // json = JSON.parse(dataop.shift());
                    // json.cizimler = {}
                    // json.operasyonlar = {}

                    // let cizimlerde = false;
                    // let aktifCizim = null;
                    // for (let i = 0; i < dataop.length; i++) {
                    //     const satir = dataop[i];
                    //     if (satir.startsWith("#$ FikoYT CIZIMLER BASLANGICI")) {
                    //         cizimlerde = true;
                    //     } else
                    //         if (satir.startsWith("#$ FikoYT CIZIMLER BITIS")) {
                    //             cizimlerde = false;
                    //             dataop.splice(0, i + 1)
                    //             break;
                    //         } else {
                    //             if (cizimlerde) {
                    //                 if (satir.startsWith("#$ FikoYT VRML CIZIM BASLANGICI")) {
                    //                     aktifCizim = satir.replace("#$ FikoYT VRML CIZIM BASLANGICI ", "").replace(".CATPart", "")
                    //                     json.cizimler[aktifCizim] = ""
                    //                 } else if (aktifCizim)
                    //                     if (!satir.startsWith("#$ FikoYT VRML CIZIM BITIS"))
                    //                         json.cizimler[aktifCizim] += satir + '\r\n'
                    //             }
                    //         }
                    // }

                    // let prgi = 0;
                    // let progBasi = null;
                    // let progSoni = null;
                    // for (let i = 0; i < dataop.length; i++) {
                    //     const satir = dataop[i];

                    //     if (satir.startsWith("#$ FikoYT PROGRAM BASLANGICI ")) {
                    //         if (progBasi == null)
                    //             progBasi = i;
                    //         else
                    //             progBasi = i;
                    //     }
                    //     if (satir.startsWith("#$ FikoYT PROGRAM BITIS ")) {
                    //         if (progSoni == null)
                    //             progSoni = i;
                    //         else
                    //             progSoni = i;

                    //         json.programlar[prgi].apt = dataop.slice(progBasi, progSoni + 1).join('\r\n');
                    //         prgi++
                    //     }
                    // }

                    sonuc.push(this.parcala(dataop))
                }

                operasyonlar = undefined;
                // console.log(sonuc)
                // console.log(json)

                data = undefined;

                resolve(sonuc);

                /** NOT: Loader Bitimi */
            });
        }

        return new Promise((resolve, reject) => {

            let _this = this;
            const loader: THREE.FileLoader = new THREE.FileLoader();
            loader.loadAsync(URL.createObjectURL(dosya)).then(async (data: any) => {
                // console.log( flate.deflate_encode(data))
                isle(data).then(() => {
                    resolve(sonuc);
                    data = undefined;
                    json = undefined;
                    sonuc=undefined;
                });

            });
            /** NOT: Promise Bitimi */
        });
    }

    parcala(veri: any) {
        let json: any;
        let data: string[];
        let isle = (dataStr: string) => {
            data = dataStr.split('\r\n');
            data.shift()
            json = JSON.parse(data.shift());

            json.cizimler = {}
            // console.log(json)

            let cizimlerde = false;
            let aktifCizim = null;
            for (let i = 0; i < data.length; i++) {
                const satir = data[i];
                if (satir.startsWith("#$ FikoYT CIZIMLER BASLANGICI")) {
                    cizimlerde = true;
                } else
                    if (satir.startsWith("#$ FikoYT CIZIMLER BITIS")) {
                        cizimlerde = false;
                        data.splice(0, i + 1)
                        break;
                    } else {
                        if (cizimlerde) {
                            if (satir.startsWith("#$ FikoYT VRML CIZIM BASLANGICI")) {
                                aktifCizim = satir.replace("#$ FikoYT VRML CIZIM BASLANGICI ", "").replace(".CATPart", "")
                                json.cizimler[aktifCizim] = ""
                            } else if (aktifCizim)
                                if (!satir.startsWith("#$ FikoYT VRML CIZIM BITIS"))
                                    json.cizimler[aktifCizim] += satir + '\r\n'
                        }
                    }
            }

            let prgi = 0;
            let progBasi = null;
            let progSoni = null;
            for (let i = 0; i < data.length; i++) {
                const satir = data[i];
                if (satir.startsWith("#$ FikoYT PROGRAM BASLANGICI ")) {
                    if (progBasi == null)
                        progBasi = i;
                    else
                        progBasi = i;
                }
                if (satir.startsWith("#$ FikoYT PROGRAM BITIS ")) {
                    if (progSoni == null)
                        progSoni = i;
                    else
                        progSoni = i;

                    json.programlar[prgi].apt = data.slice(progBasi, progSoni + 1).join('\r\n');
                    prgi++
                }
            }

            // console.log(json)

            data = undefined;
            return json;

            /** NOT: Loader Bitimi */

        }

        return isle(veri)

    }


}